import React from "react";
import Icon from "components/AppIcon";

const capabilities = [
  {
    icon: "Wand2",
    title: "AI-Powered Creation",
    description: "Describe your game idea in plain English and watch AI build it in seconds.",
    color: "var(--color-primary)",
  },
  {
    icon: "Shield",
    title: "Child-Safe Platform",
    description: "Advanced content moderation ensures all content is appropriate for ages 8+.",
    color: "var(--color-success)",
  },
  {
    icon: "Zap",
    title: "Instant Playability",
    description: "Every generated game is immediately playable in your browser — no downloads needed.",
    color: "var(--color-accent)",
  },
  {
    icon: "Share2",
    title: "Share & Discover",
    description: "Publish your creations and explore thousands of games made by the community.",
    color: "var(--color-secondary)",
  },
];

const certifications = [
  { icon: "ShieldCheck", label: "COPPA Compliant" },
  { icon: "Lock", label: "SSL Secured" },
  { icon: "Star", label: "ESRB Safe" },
  { icon: "Users", label: "Family Friendly" },
];

export default function CapabilitySection() {
  return (
    <section className="py-10 md:py-14 lg:py-16">
      <div className="text-center mb-8 md:mb-10">
        <h2
          className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl mb-3"
          style={{ color: "var(--color-foreground)" }}
        >
          Everything You Need to Create
        </h2>
        <p className="text-sm md:text-base max-w-xl mx-auto" style={{ color: "var(--color-muted-foreground)" }}>
          GameForge combines cutting-edge AI with a safe, intuitive platform so anyone can become a game creator.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-10 md:mb-12">
        {capabilities?.map((cap) => (
          <div
            key={cap?.title}
            className="flex flex-col items-start p-5 md:p-6 rounded-2xl border"
            style={{ background: "var(--color-card)", borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}
          >
            <div
              className="flex items-center justify-center w-11 h-11 rounded-xl mb-4"
              style={{ background: `${cap?.color}18` }}
            >
              <Icon name={cap?.icon} size={22} color={cap?.color} />
            </div>
            <h3 className="font-heading font-semibold text-sm md:text-base mb-1" style={{ color: "var(--color-foreground)" }}>
              {cap?.title}
            </h3>
            <p className="text-xs md:text-sm" style={{ color: "var(--color-muted-foreground)" }}>
              {cap?.description}
            </p>
          </div>
        ))}
      </div>
      {/* Trust badges */}
      <div
        className="flex flex-wrap items-center justify-center gap-4 md:gap-6 py-5 px-6 rounded-2xl border"
        style={{ background: "var(--color-muted)", borderColor: "var(--color-border)" }}
      >
        {certifications?.map((cert) => (
          <div key={cert?.label} className="flex items-center gap-2">
            <Icon name={cert?.icon} size={18} color="var(--color-success)" />
            <span className="text-xs md:text-sm font-medium" style={{ color: "var(--color-foreground)" }}>
              {cert?.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}